export default {
  roles (state) {
    return {
      ...state,
      storeName: 'roles'
    }
  }
}
